<script setup lang="ts">
import { SOCIAL_LINKS } from './consts'
import { SvgIcon } from '~/components/ui/svg-icon'
</script>

<template>
  <nav class="flex gap-6 text-gray-400">
    <a
      v-for="(socialLink, index) in SOCIAL_LINKS"
      :key="index"
      :href="socialLink.url"
      :title="socialLink.title"
      :aria-label="socialLink.title"
      :class="socialLink.className"
      class="block transition"
      target="_blank"
    >
      <SvgIcon :path="socialLink.path" class="size-6" />
    </a>
  </nav>
</template>
